import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';

import useArchiveObjectDoc from 'hooks/ObjectDocs/useDeleteObjectDoc';
import useGetObjectDocs from 'hooks/ObjectDocs/useGetObjectDocs';

interface ObjectDocDeleteModalProps {
  slug: string;
  docID: number;
  docName: string;
  isOpen: boolean;
  onClose: () => void;
}

const ObjectDocDeleteModal: React.FC<ObjectDocDeleteModalProps> = ({ slug, docID, docName, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { archiveObjectDoc, isLoading } = useArchiveObjectDoc();
  const { refetch } = useGetObjectDocs(slug);

  const onArchive = () => {
    archiveObjectDoc(
      { slug, docID },
      {
        onSuccess: () => {
          enqueueSnackbar('Document archived successfully', { variant: 'success' });
          onClose();
          refetch();
        },
        onError: () => {
          enqueueSnackbar('Error archiving document', { variant: 'error' });
          onClose();
        },
      },
    );
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md">
      <ModalBody>
        <div className="d-flex flex-column justify-content-center">
          <div className="d-flex align-items-center justify-content-center">
            <WarningIcon color="warning" fontSize="large" style={{ width: '100px', height: '100px' }} />
          </div>
          <h4 className="text-center">
            {t('ObjectDocs.delete-modal.title-1')}
            {docName} {t('ObjectDocs.delete-modal.title-2')}
          </h4>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button color="warning" onClick={onArchive} disabled={isLoading}>
          {t('ObjectDocs.delete-modal.submit-btn')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ObjectDocDeleteModal;
